<template>
  <div class="toc">
    <div v-if="comp">
      <div class="toc__wrapper" v-for="(item, index) in chapters" :key="index">
        <a
          :href="'#' + slugify(item.Tittel)"
          class="toc__main"
          :key="item.id"
          >{{ item.Tittel }}</a
        >
        <a
          v-for="(sub, index) in getSubtitles(item)"
          :href="'#' + slugify(item.Tittel) + '-' + slugify(sub.Undertittel)"
          :key="item.id + index"
          class="toc__sub"
          >{{ sub.Undertittel }}</a
        >
      </div>
    </div>

    <div v-if="!comp">
      <div
        class="toc__wrapper"
        v-for="(item, index) in chapters"
        :key="index + '_en'"
      >
        <a
          :href="'#' + slugify(item.Tittel)"
          class="toc__main"
          :key="item.kapittel.id"
          >{{ item.Tittel_eng }}</a
        >
        <a
          v-for="(sub, index) in getSubtitles(item)"
          :href="'#' + slugify(item.Tittel) + '-' + slugify(sub.Undertittel)"
          :key="item.id + index"
          class="toc__sub"
          >{{ sub.Undertittel_eng }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Slugify as slugify } from "@/utils";

export default {
  props: {
    chapters: Array,
  },
  methods: {
    getSubtitles(item) {
      return item.kapittel.blocks.filter(
        (b) => b.__typename === "ComponentElementUndertittel"
      );
    },
    slugify,
  },
  computed: {
    api() {
      return process.env.strapiBaseUri;
    },
    comp() {
      if (this.$i18n.locale == "no") {
        return true;
      }
    },
  },
  data() {
    return {
      locale: null,
    };
  },
};
</script>

<style lang="scss">
.toc {
  $spacing: 1.5em;

  a:hover {
    opacity: 0.8;
  }

  @media (min-width: 900px) {
    columns: 3;
    column-gap: 4em;
  }

  &__wrapper {
    break-inside: avoid;
  }

  a {
    color: #333333;
    display: block;
    text-decoration: none !important;
  }

  &__main {
    font-weight: bold;
    margin-bottom: $spacing;

    & + .toc__sub {
      margin-top: -$spacing;
    }
  }

  &__sub {
    font-size: 0.9em;
    margin-bottom: $spacing;

    & + & {
      margin-top: -$spacing;
    }
  }
}
</style>
